import { ScreenReaderAlert } from '@core/accessibility/screenReader/ScreenReaderAlert';
import { FocusTrap } from '@core/components/FocusTrap';
import { useContextTranslation } from '@core/i18n';
import { PlayerModal } from '@embed/components/VideoPlayer/Player3/components/PlayerModal';
import Modal from '@player/components/Modal';
import { ModalCopyWrapper } from './ModalCopy.styles';
/**
 *
 */
export const ModalCopy = ({ setReturnFocus }) => {
    const { t } = useContextTranslation();
    return (<FocusTrap options={{ setReturnFocus: setReturnFocus || false }}>
      <PlayerModal>
        <Modal.Menu>
          <Modal.Group>
            <Modal.Item>
              <ModalCopyWrapper>
                <ScreenReaderAlert visible={true}>
                  {t('Link Copied')}
                </ScreenReaderAlert>
              </ModalCopyWrapper>
            </Modal.Item>
          </Modal.Group>
        </Modal.Menu>
      </PlayerModal>
    </FocusTrap>);
};
